import React, { useEffect, useState } from 'react';
import axios, { formToJSON } from 'axios';

import { apiConfig } from '../helper/apiConfig';

const SisaSaldo = (param) => {

    const token = localStorage.getItem('token');
    const config = apiConfig(token);
    const mainhost = process.env.REACT_APP_API_HOST_MASTER;
    const [bankIncome,setBankIncome] = useState([
        { bank: 'Bank A', balance: 1000 },
        { bank: 'Bank B', balance: 2000 },
        { bank: 'Bank C', balance: 3000 },
    ]);

    const [totalCreditDebit,setDataInOut] = useState([]);

    const formatNumberWithoutDecimals = (num) => {
        // convert num into float
        num = parseFloat(num);
        if (isNaN(num)) {
        return '0';
        }
        return num.toLocaleString('id-ID', { minimumFractionDigits: 0, maximumFractionDigits: 0 });
    };
    useEffect(() => {
        setBankIncome(param.bankIncome);
        setDataInOut(param.dataInOut);
    });
    return (
        <div>
            <table style={{ width:'100%', paddingBottom:"50px"}}>
                <tr>
                    <th>Dana Masuk</th>
                    <th></th>
                    <th>Sisa Saldo</th>
                </tr>
                <tr>
                    <td style={{ width:'40%', textAlign:"center", padding:'0px 1%'}}>
                        <table style={{ width:'100%'}} className="table table-bordered">
                            <thead>
                                <tr>
                                    <th style={{ width: '120px'}}>Bank</th>
                                    <th style={{ width: '120px'}}>Balance</th>
                                </tr>
                            </thead>
                            <tbody>
                                {bankIncome.map((item, index) => (
                                    <tr key={index}>
                                        <td>{item.bank}</td>
                                        <td style={{ textAlign:"right"}}>{formatNumberWithoutDecimals(item.balance)}</td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </td>
                    <td>

                    </td>
                    <td style={{ width:'40%', textAlign:"center", padding:'1%'}}>
                        <table style={{ width:'100%'}} className="table table-bordered">
                            <thead>
                                <tr>
                                    <th style={{ width: '120px'}}>Bank</th>
                                    <th style={{ width: '120px'}}>Amount</th>
                                </tr>
                            </thead>
                            <tbody>
                                {totalCreditDebit.map((item, index) => (
                                    <tr key={index}>
                                        <td>{item.bank}</td>
                                        <td style={{ textAlign:"right"}}>{formatNumberWithoutDecimals(item.total)}</td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </td>
                </tr>
            </table>
        </div>
    );
};

export default SisaSaldo;